import { DC_CompanyName } from "../config";

//API Constants
export const userBaseUrl = process.env.REACT_APP_API_BASE_URL + "/api";
export const devBaseUrl = process.env.REACT_APP_API_BASE_URL + "/dev";
export const loginBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const LOCAL =
	process.env.REACT_APP_GO_BASE_URL || "http://localhost:8080";
export const LOCAL8081 = "http://localhost:8081";
export const DC_AI_API_BASE_URL = "https://goroutes.dealerclick.com";
export const OPEN_AI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

export const PATHS = {
	//Base
	DEV: "/dev",

	//Paths
	DATA_LOADING: "/data-loading",
	DASHBOARD: "/dashboard",
	LOGIN: "/login",
	INVENTORY_LIST: "/inventory-list",
	INVENTORY_SEARCH_LIST: "/inventory-search-list",
	INVENTORY_ADD: "/inventory-add",
	INVENTORY_APPRAISAL: "/inventory-appraisal",
	INVENTORY_REPORTS: "/inventory-reports",
	INVENTORY_DETAIL: "/inventory-detail",
	CUSTOMER_LIST: "/customer-list",
	CUSTOMER_ADD: "/customer-add",
	CUSTOMER_DETAIL: "/customer-detail",
	CUSTOMER_SEARCH_LIST: "/customer-search-list",
	MESSAGING: "/message",
	MESSAGE_RECENT: "/messages/recent",
	LEAD_ADD: "/lead-add",
	LEAD_LIST: "/lead-list",
	CreditApp_LIST: "/CreditApp-list",
	LEAD_DETAIL: "/lead-detail",
	COMMUNICATIONS: "/communications",
	MESSAGE_TEMPLATES: "/message-templates",
	CREDIT_APPS: "/credit-apps",
	DEAL_LIST: "/deal-list",
	Acounts_LIST: "/acounts-LIST",
	DEAL_ADD: "/deal-add",
	DEAL_SETTINGS: "/deal-settings",
	DEAL_DETAIL: "/deal-detail",
	DEAL_SEARCH_LIST: "/deal-search-list",
	BUY_HERE_PAY_HERE: "/buy-here-pay-here",
	PAYMENT_ADD: "/payment-add",
	USER_PROFILE: "/user-profile",
	REPORTS: "/reports",
	BUYERS_GUIDE: "/buyers-guide",
	SETTINGS: "/settings",
	NEW_USER: "/new-user",
	USER_ACCOUNT: "/user-account",
	PAYMENT_TERMINAL: "/payment-terminal",
	DEALER_GPT: "/dealer-gpt",
	INVENTORY_ADVERTISING: "/inventory-advertising",
	VENDORS: "/vendors",
	UPDATE_PASSWORD: "/update-password",
	FORGOTTEN_PASSWORD: "/forgotten-password",
	BackDoor_Login: "/backdoor_login",
	FormGen: "/formgen",
	QuickQuote: "/QuickQuote",
	MultiDealer: "/multi-dealer",

	ACCT_LIST: "/acct_list",
	ACCT_DETAIL: "/acct_detail",
	ACCT_PAYMENT_LIST: "/acct_payment_list",
	ACCT_ADD: "/acct_add",
	ACCT_SEARCH_LIST: "/acct_search_list",
	ACCT_MODIFY: "/acct_modify",
	SCHEDULE_TASK: "/schedule_task",
};

/**
 * Takes in an enumerated object and returns an array used for selectors.
 * Enumerated objects are good for accessing values without having to rely on index
 * @param {*} enumObj
 * @returns
 */
export const getOptions = (enumObj) => {
	return Object.keys(enumObj).map((option) => enumObj[option]);
};
// Public Const VENDOR_TYPE_VENDOR As Integer = 10
// Public Const VENDOR_TYPE_WARRANTY As Integer = 20
// Public Const VENDOR_TYPE_WARRANTY_LienHolder As Integer = 25
// Public Const VENDOR_TYPE_LENDER As Integer = 30
// Public Const VENDOR_TYPE_ADDL_DEALER As Integer = 40
// Public Const VENDOR_TYPE_RECON_SUPPLIER As Integer = 50
// Public Const VENDOR_TYPE_AFTMKT_SUPPLIER As Integer = 60
// Public Const VENDOR_TYPE_FLOORING_VENDOR As Integer = 70
// Public Const VENDOR_TYPE_TradeLender As Integer = 80

export const vendorTypesOBJ = {
	VENDOR: { value: 10, label: "Vendor" },
	WARRANTY: { value: 20, label: "Warranty" },
	//LienHolder: { value: 25, label: "Lien Holder" },
	LENDER: { value: 30, label: "Lender" },
	DEALERCLICK_LENDER: { value: 31, label: DC_CompanyName + " Lender" },
	SHIPPING_COMPANIES: { value: 40, label: "Shipping Companies" },
	RECON_SUPPLIER: { value: 50, label: "Recon Supplier" },
	AFTMKT_SUPPLIER: { value: 60, label: "Aftermarket Supplier" },
	FLOORING_VENDOR: { value: 70, label: "Flooring Vendor" },
	//TradeLender: { value: 80, label: "Trade Lender" },
	GAP_COMPANIES: { value: 90, label: "Gap/Insurance Companies" },
};

export const PayOffMethod = [
	{ value: 0, label: "RULE_OF_78" },
	{ value: 1, label: "SIMPLE_INT" },
	//	{ value: 2, label: "NO_INT" },
	{ value: 3, label: "SCHEDULE_INT" },
	{ value: 4, label: "LEASE" },
	{ value: 5, label: "RTO" },
];

export const vendorTypes = {
	10: "Vendor",
	20: "Warranty",
	//	25: "Lien Holder",
	30: "Lender",
	40: "Shipping Companies",
	50: "Recon Supplier",
	60: "Aftermarket Supplier",
	70: "Flooring Vendor",
	//	80: "Trade Lender",
	90: "Gap/Insurance Companies",
};
export const INS_TYPE = [
	{ value: 0, label: "None" },
	{ value: 1, label: "SINGLE_LIFE" },
	{ value: 2, label: "JOINT_LIFE" },
];
export const INS_TYPE_AH = [
	{ value: 0, label: "None" },
	{ value: 3, label: "14 DAYS RETRO" },
	{ value: 4, label: "7  DAYS RETRO" },
	{ value: 5, label: "30 DAYS RETRO" },
];
export const taxRateEnum = {
	SPECIFIC_RATE: 1,
	NONTAXABLE: 0,
	DEFAULT_TAX_RATE: -1,
};
export const genderType = [
	{ value: "M", label: "Male" },
	{ value: "F", label: "Female" },
	{ value: "O", label: "Other" },
];
export const generationType = [
	{ value: "", label: "" },
	{ value: "N/A", label: "N/A" },
	{ value: "Sr", label: "Sr" },
	{ value: "Jr", label: "Jr" },
	{ value: "2nd", label: "2nd" },
	{ value: "3rd", label: "3rd" },
	{ value: "4th", label: "4th" },
	{ value: "I", label: "I" },
	{ value: "II", label: "II" },
	{ value: "III", label: "III" },
	{ value: "IV", label: "IV" },
];
export const titleStatusOptions = [
	{ label: "Clean", value: "Clean" },
	{ label: "Salvage", value: "Salvage" },
	{ label: "Bonded", value: "Bonded" },
	{ label: "Lemon", value: "Lemon" },
	{ label: "Rebuilt", value: "Rebuilt" },
	{ label: "Dismantled", value: "Dismantled" },
	{ label: "Junk", value: "Junk" },
	{ label: "Flood/Water Damage", value: "Flood/Water Damage" },
];

export const stateOptions = [
	{ label: "AK", value: "AK" },
	{ label: "AL", value: "AL" },
	{ label: "AR", value: "AR" },
	{ label: "AZ", value: "AZ" },
	{ label: "CA", value: "CA" },
	{ label: "CR", value: "CR" },
	{ label: "CO", value: "CO" },
	{ label: "CT", value: "CT" },
	{ label: "DE", value: "DE" },
	{ label: "FL", value: "FL" },
	{ label: "GA", value: "GA" },
	{ label: "HI", value: "HI" },
	{ label: "IA", value: "IA" },
	{ label: "ID", value: "ID" },
	{ label: "IL", value: "IL" },
	{ label: "IN", value: "IN" },
	{ label: "KS", value: "KS" },
	{ label: "KY", value: "KY" },
	{ label: "LA", value: "LA" },
	{ label: "MA", value: "MA" },
	{ label: "MD", value: "MD" },
	{ label: "ME", value: "ME" },
	{ label: "MI", value: "MI" },
	{ label: "MN", value: "MN" },
	{ label: "MO", value: "MO" },
	{ label: "MS", value: "MS" },
	{ label: "MT", value: "MT" },
	{ label: "NC", value: "NC" },
	{ label: "ND", value: "ND" },
	{ label: "NE", value: "NE" },
	{ label: "NH", value: "NH" },
	{ label: "NJ", value: "NJ" },
	{ label: "NM", value: "NM" },
	{ label: "NV", value: "NV" },
	{ label: "NY", value: "NY" },
	{ label: "OH", value: "OH" },
	{ label: "OK", value: "OK" },
	{ label: "OR", value: "OR" },
	{ label: "PA", value: "PA" },
	{ label: "PR", value: "PR" },
	{ label: "RI", value: "RI" },
	{ label: "SC", value: "SC" },
	{ label: "SD", value: "SD" },
	{ label: "TN", value: "TN" },
	{ label: "TX", value: "TX" },
	{ label: "UT", value: "UT" },
	{ label: "VA", value: "VA" },
	{ label: "VI", value: "VI" },
	{ label: "VT", value: "VT" },
	{ label: "WA", value: "WA" },
	{ label: "WI", value: "WI" },
	{ label: "WV", value: "WV" },
	{ label: "WY", value: "WY" },
];
export const StateCodeByStateName = [
	{ label: "Armed Forces America	", value: "AA" },
	{ label: "Armed Forces", value: "AE" },
	{ label: "Alaska", value: "AK" },
	{ label: "Alabama", value: "AL" },
	{ label: "Armed Forces Pacific", value: "AP" },
	{ label: "Arkansas", value: "AR" },
	{ label: "Arizona", value: "AZ" },
	{ label: "California", value: "CA" },
	{ label: "Colorado", value: "CO" },
	{ label: "Costa Rica", value: "CR" },
	{ label: "Connecticut", value: "CT" },
	{ label: "Washington DC", value: "DC" },
	{ label: "Delaware", value: "DE" },
	{ label: "Florida", value: "FL" },
	{ label: "Georgia", value: "GA" },
	{ label: "Guam", value: "GU" },
	{ label: "Hawaii", value: "HI" },
	{ label: "Iowa", value: "IA" },
	{ label: "Idaho", value: "ID" },
	{ label: "Illinois", value: "IL" },
	{ label: "Indiana", value: "IN" },
	{ label: "Kansas", value: "KS" },
	{ label: "Kentucky", value: "KY" },
	{ label: "Louisiana", value: "LA" },
	{ label: "Massachusetts", value: "MA" },
	{ label: "Maryland", value: "MD" },
	{ label: "Maine", value: "ME" },
	{ label: "Michigan", value: "MI" },
	{ label: "Minnesota", value: "MN" },
	{ label: "Missouri", value: "MO" },
	{ label: "Mississippi", value: "MS" },
	{ label: "Montana", value: "MT" },
	{ label: "North Carolina", value: "NC" },
	{ label: "North Dakota", value: "ND" },
	{ label: "Nebraska", value: "NE" },
	{ label: "New Hampshire", value: "NH" },
	{ label: "New Jersey", value: "NJ" },
	{ label: "New Mexico", value: "NM" },
	{ label: "Nevada", value: "NV" },
	{ label: "New York", value: "NY" },
	{ label: "Ohio", value: "OH" },
	{ label: "Oklahoma", value: "OK" },
	{ label: "Oregon", value: "OR" },
	{ label: "Pennsylvania", value: "PA" },
	{ label: "Puerto Rico", value: "PR" },
	{ label: "Rhode Island", value: "RI" },
	{ label: "South Carolina", value: "SC" },
	{ label: "South Dakota", value: "SD" },
	{ label: "Tennessee", value: "TN" },
	{ label: "Texas", value: "TX" },
	{ label: "Utah", value: "UT" },
	{ label: "Virginia", value: "VA" },
	{ label: "Virgin Islands", value: "VI" },
	{ label: "Vermont", value: "VT" },
	{ label: "Washington", value: "WA" },
	{ label: "Wisconsin", value: "WI" },
	{ label: "West Virginia", value: "WV" },
	{ label: "Wyoming", value: "WY" },
];

export const vehicleTypesOBJ = {
	ATV: { label: "ATV", value: "ATV" },
	BOAT: { label: "Boat", value: "Boat" },
	BUS: { label: "Bus", value: "Bus" },
	CAMPER: { label: "Camper", value: "Camper" },
	CAR: { label: "Car", value: "Car" },
	E_BIKES: { label: "e-bikes", value: "e-bikes" },
	GOLF_CART: { label: "Golf cart", value: "Golf cart" },
	GO_KART: { label: "Go-Kart", value: "Go-Kart" },
	MARINE: { label: "Marine", value: "Marine" },
	MOTOR_SCOOTER: { label: "Motor-Scooter", value: "Motor-Scooter" },
	MOTORCYCLE: { label: "Motorcycle", value: "Motorcycle" },
	MOTORHOME: { label: "Motorhome", value: "Motorhome" },
	RV: { label: "RV", value: "RV" },
	SNOWMOBILE: { label: "Snowmobile", value: "Snowmobile" },
	SUV: { label: "SUV", value: "SUV" },
	TRACTOR: { label: "Tractor", value: "Tractor" },
	TRAILER: { label: "Trailer", value: "Trailer" },
	TRUCK: { label: "Truck", value: "Truck" },
	MINI_TRUCK: { label: "Mini Truck", value: "Mini Truck" },
	MOWER: { label: "Mower", value: "Mower" },
	SEMI_TRUCKS: { label: "Semi-trucks", value: "Semi-trucks" },
	SEMI_TRAILER: { label: "Semi-Trailer Truck", value: "Semi-Trailer Truck" },
	UTV: { label: "UTV", value: "UTV" },
	VAN: { label: "Van", value: "Van" },
	OTHER: { label: "Other", value: "Other" },
};

export const vehicleTypeOptions = [...getOptions(vehicleTypesOBJ)];

export const vehicleCategories = [
	{ label: "None", value: 0 },
	{ label: "Chassis", value: 1 },
	{ label: "Dump", value: 2 },
	{ label: "Grain/Hopper", value: 3 },
	{ label: "Platform/Flatbed", value: 4 },
	{ label: "Tanker", value: 5 },
	{ label: "Utility", value: 6 },
	{ label: "RV", value: 7 },
	{ label: "Lowboy", value: 8 },
	{ label: "Paver", value: 9 },
	{ label: "Stepdeck (Drop Deck)", value: 10 },
	{ label: "Cargo", value: 11 },
	{ label: "Equipment", value: 12 },
	{ label: "Car Haulers", value: 13 },
	{ label: "Gooseneck", value: 14 },
	{ label: "Snow/ATV", value: 15 },
	{ label: "Tilt", value: 16 },
	{ label: "Refrigerated", value: 17 },
	{ label: "Tank", value: 18 },
	{ label: "Horse", value: 19 },
	{ label: "Livestock", value: 20 },
	{ label: "Concession", value: 21 },
	{ label: "Landscape", value: 22 },
	{ label: "Office", value: 23 },
];

export const vehicleSubCategories = [
	{ label: "None", value: 0 },
	{ label: "Boat", value: 1 },
	{ label: "Chipper", value: 2 },
	{ label: "Curtain Side", value: 3 },
	{ label: "Dolly", value: 4 },
	{ label: "Insulated", value: 5 },
	{ label: "Mixer", value: 6 },
	{ label: "Motorcycle", value: 7 },
	{ label: "Open", value: 8 },
	{ label: "Travel Trailer", value: 9 },
	{ label: "Toy Hauler", value: 10 },
	{ label: "Pop Up", value: 11 },
	{ label: "Park Trailer", value: 12 },
	{ label: "Truck Camper", value: 13 },
	{ label: "Vertical Telescoping", value: 14 },
	{ label: "Teardrop", value: 15 },
];

// export const newUseOptions = [
// 	{ label: "New", value: "New" },
// 	{ label: "Used", value: "Used" },
// 	{ label: "Demo", value: "Demo" },
// 	{ label: "Consign", value: "Consign" },
// 	{ label: "Trade-In", value: "Trade-In" },
// 	{ label: "BroKered", value: "BroKered" },
// 	{ label: "Wholesale", value: "Wholesale" },
// 	{ label: "Pre-Owned", value: "Pre-Owned" },
// 	{ label: "Certified Pre-Owned", value: "Certified Pre-Owned" },
// ];
export const conditionOptions = [
	{ label: "Excellent", value: "Excellent" },
	{ label: "Very Good", value: "Very Good" },
	{ label: "Good", value: "Good" },
	{ label: "Fair", value: "Fair" },
];

export const kbbConditionOptions = [
	{ label: "Fair", value: "Fair" },
	{ label: "Good", value: "Good" },
	{ label: "Very Good", value: "Very Good" },
	{ label: "Excellent", value: "Excellent" },
];

export const newOrUsed = [
	{ label: "New", value: "New" },
	{ label: "Used", value: "Used" },
];

export const SaleTypeEnum = {
	RETAIL: { label: "RETAIL", value: 0 },
	WHOLESALE: { label: "WHOLESALE", value: 1 },
	BUSINESS: { label: "BUSINESS", value: 2 },
	BULK_WHOLESALE: { label: "BULK WHOLESALE", value: 3 },
	BULK_RETAIL: { label: "BULK RETAIL", value: 4 },
	// { label: "DEALER_TRADE", value: 4 },
	//	PURCHASE: { label: "PURCHASE", value: 5 },
	LEASE: { label: "LEASE", value: 5 },
	RTO: { label: "RTO", value: 6 },
	QUICK_DEAL: { label: "QUICK_DEAL", value: 8 },
};

export const SaleType = [...getOptions(SaleTypeEnum)];
export const LoanPeriodEnum = {
	WEEKLY: { label: "WEEKLY", term: 52, daysInPeriod: 7, value: 0 },
	BIWEEKLY: { label: "BIWEEKLY", term: 26, daysInPeriod: 14, value: 1 },
	SEMIMONTHLY: { label: "SEMIMONTHLY", term: 24, daysInPeriod: 15, value: 2 },
	MONTHLY: { label: "MONTHLY", term: 12, daysInPeriod: 30, value: 3 },
	ANNUALLY: { label: "ANNUALLY", term: 1, daysInPeriod: 360, value: 4 },
	COD: { label: "COD", term: 1, daysInPeriod: 0, value: 5 },
	BIANNUALLY: { label: "BIANNUALLY", term: 2, daysInPeriod: 180, value: 6 },
};
// daysInPeriod is derived from Peymans code, it is constant
export const LoanPeriod = [...getOptions(LoanPeriodEnum)];

export const DealType = [
	{ label: "PURCHASE", value: "Purchase" },
	{ label: "PENDING", value: "Pending" },
	{ label: "SOLD", value: "Sold" },
	{ label: "REPO", value: "Repo" },
	{ label: "DELETED", value: "Deleted" },
	{ label: "FUNDED", value: "Funded" },
];
export const TaxRegion = [
	{ label: "Customer Zip", value: 0 },
	{ label: "Dealership Zip", value: 1 },
	{ label: "Manual", value: 2 },
];
export const TaxType = [
	{ label: "Advanced", value: 0 },
	{ label: "Deferred", value: 1 },
];

export const vehicleCostType = [
	{ label: "Reconditioning", value: 0 },
	{ label: "Flooring", value: 2 },
	{ label: "Other", value: 9 },
];

// AutoInventory equivalents
export const vehicleStatusDesc = [
	{ label: "AVAILABLE", value: 0 },
	{ label: "SOLD", value: 1 },
	{ label: "PENDING", value: 2 },
	{ label: "HOLD", value: 3 },
	{ label: "DELETED", value: 4 },
	{ label: "APPRAISAL", value: 5 },
	{ label: "TRADE", value: 6 },
	{ label: "SOLD WITHOUT DEAL", value: 9 },
	{ label: "Non Stock", value: 99 },
];
export const vehicleStatusList = [
	{ label: "AVAILABLE", value: "Available" },
	{ label: "SOLD", value: "Sold" },
	{ label: "PENDING", value: "Pending" },
	{ label: "HOLD", value: "Hold" },
	{ label: "DELETED", value: "Deleted" },
	{ label: "APPRAISAL", value: "Appraisal" },
	{ label: "TRADE", value: "Trade" },
	{ label: "SOLD WITHOUT DEAL", value: "Sold Without Deal" },
	{ label: "NON STOCK", value: "Non Stock" },
];

export const vehicleStatus = {
	AVAILABLE: "Available",
	SOLD: "Sold",
	PENDING: "Pending",
	HOLD: "Hold",
	DELETED: "Deleted",
	APPRAISAL: "Appraisal",
	TRADE: "Trade",
	SOLDWITHOUTDEAL: "Sold Without Deal",
	NONSTOCK: "Non Stock",
};

export const personnelType = [
	{ label: "Salesperson", value: 0 },
	{ label: "Closer", value: 1 },
	{ label: "Manager", value: 2 },
	{ label: "F & I Manager", value: 3 },
	{ label: "Clerical", value: 4 },
	{ label: "Other", value: 5 },
	{ label: "Service Technician", value: 6 },
	{ label: "Owner", value: 9 },
];

export const defaultPictureURL =
	"https://www.dealernetwork.com/images/inventory/nopicture1.jpg";
export const FTP_IMAGE_URL = "https://www.dealernetwork.com/images/inventory";

export const profitSettingsEnum = {
	NOT_PROFIT: { value: 0, label: "Not Profit" },
	FRONT: { value: 1, label: "Frontend Profit" },
	BACK: { value: 2, label: "Backend Profit" },
};

export const commissionSettingsEnum = {
	NO_COMMISSION: { value: 0, label: "Not commissionable" },
	FRONT_COMMISSION: { value: 1, label: "Frontend(SP) commissionable" },
	BACK_COMMISSION: { value: 2, label: "Backend(FI) commissionable" },
	BOTH_COMMISION: { value: 3, label: "Both(SP & FI) commisionable" },
};

export const commissionSettingsOptions = [
	commissionSettingsEnum.NO_COMMISSION,
	commissionSettingsEnum.FRONT_COMMISSION,
	commissionSettingsEnum.BACK_COMMISSION,
	commissionSettingsEnum.BOTH_COMMISION,
];
export const commTypeList = {
	SALE: { value: 10, label: "SALE" },
	FI: { value: 30, label: "F&I" },
	TOTAL: { value: 40, label: "TOTAL" },
	NETPROFIT: { value: 50, label: "NET_PROFIT" },
};
export const commType = [
	{ value: 10, label: "SALE" },
	{ value: 30, label: "F&I" },
	{ value: 40, label: "TOTAL" },
	{ value: 50, label: "NET_PROFIT" },
];
// export const commType = {
// 	10: "SALESPERSON",
// 	30: "CLOSER",
// 	40: "MANAGER",
// 	50: "FI_MANAGER",
// };

export const DealStatus = {
	PURCHASE: "Purchase",
	PENDING: "Pending",
	SOLD: "Sold",
	REPO: "Repo",
	DELETED: "Deleted",
	FUNDED: "Funded",
	VOID: "Void",
};

export const CustomerStatus = {
	PENDING: 0,
	SOLD: 1,
	DELETED: 2,
};

export const HousingStatus = [
	{ label: "Rent", value: "rent" },
	{ label: "Own", value: "own" },
	{ label: "Other", value: "Other" },
];

export const IncomeType = [
	{ label: "Pay Stub", value: "paystub" },
	{ label: "Cash Bank Statements", value: "cash-paid-bank-stmts" },
	{ label: "Job Letter", value: "job-letter" },
	{ label: "Permanent Disability", value: "perm-disability" },
	{ label: "Retirement", value: "retirement" },
	{ label: "Social Security Income", value: "social-security-income" },
	{ label: "VA Income", value: "va-income" },
	{ label: "Self-employment Tax Returns", value: "self-empl-tax-rtns" },
	{ label: "Self-employment Bank Statements", value: "self-empl-bank-stmts" },
	{ label: "Temporary Job", value: "temporary-job" },
	{ label: "Other", value: "other" },
];

export const EmployerType = [
	{ label: "Current Employer/Employment", value: "current" },
	{ label: "Secondary Employer/Employment", value: "secondary" },
	{ label: "Previous Employer/Employment", value: "previous" },
];

export const CountryCodes = [
	{ label: "Afghanistan", value: "AFG" },
	{ label: "Albania", value: "ALB" },
	{ label: "Algeria", value: "DZA" },
	{ label: "Andorra", value: "AND" },
	{ label: "Angola", value: "AGO" },
	{ label: "Antigua and Barbuda", value: "ATG" },
	{ label: "Argentina", value: "ARG" },
	{ label: "Armenia", value: "ARM" },
	{ label: "Australia", value: "AUS" },
	{ label: "Austria", value: "AUT" },
	{ label: "Azerbaijan", value: "AZE" },
	{ label: "Bahamas", value: "BHS" },
	{ label: "Bahrain", value: "BHR" },
	{ label: "Bangladesh", value: "BGD" },
	{ label: "Barbados", value: "BRB" },
	{ label: "Belarus", value: "BLR" },
	{ label: "Belgium", value: "BEL" },
	{ label: "Belize", value: "BLZ" },
	{ label: "Benin", value: "BEN" },
	{ label: "Bhutan", value: "BTN" },
	{ label: "Bolivia", value: "BOL" },
	{ label: "Bosnia and Herzegovina", value: "BIH" },
	{ label: "Botswana", value: "BWA" },
	{ label: "Brazil", value: "BRA" },
	{ label: "Brunei Darussalam", value: "BRN" },
	{ label: "Bulgaria", value: "BGR" },
	{ label: "Burkina Faso", value: "BFA" },
	{ label: "Burundi", value: "BDI" },
	{ label: "Cabo Verde", value: "CPV" },
	{ label: "Cambodia", value: "KHM" },
	{ label: "Cameroon", value: "CMR" },
	{ label: "Canada", value: "CAN" },
	{ label: "Central African Republic", value: "CAF" },
	{ label: "Chad", value: "TCD" },
	{ label: "Chile", value: "CHL" },
	{ label: "China", value: "CHN" },
	{ label: "Colombia", value: "COL" },
	{ label: "Comoros", value: "COM" },
	{ label: "Congo (Brazzaville)", value: "COG" },
	{ label: "Congo (Kinshasa)", value: "COD" },
	{ label: "Costa Rica", value: "CRI" },
	{ label: "Croatia", value: "HRV" },
	{ label: "Cuba", value: "CUB" },
	{ label: "Cyprus", value: "CYP" },
	{ label: "Czechia", value: "CZE" },
	{ label: "Denmark", value: "DNK" },
	{ label: "Djibouti", value: "DJI" },
	{ label: "Dominica", value: "DMA" },
	{ label: "Dominican Republic", value: "DOM" },
	{ label: "Ecuador", value: "ECU" },
	{ label: "Egypt", value: "EGY" },
	{ label: "El Salvador", value: "SLV" },
	{ label: "Equatorial Guinea", value: "GNQ" },
	{ label: "Eritrea", value: "ERI" },
	{ label: "Estonia", value: "EST" },
	{ label: "Eswatini", value: "SWZ" },
	{ label: "Ethiopia", value: "ETH" },
	{ label: "Fiji", value: "FJI" },
	{ label: "Finland", value: "FIN" },
	{ label: "France", value: "FRA" },
	{ label: "Gabon", value: "GAB" },
	{ label: "Gambia", value: "GMB" },
	{ label: "Georgia", value: "GEO" },
	{ label: "Germany", value: "DEU" },
	{ label: "Ghana", value: "GHA" },
	{ label: "Greece", value: "GRC" },
	{ label: "Grenada", value: "GRD" },
	{ label: "Guatemala", value: "GTM" },
	{ label: "Guinea", value: "GIN" },
	{ label: "Guinea-Bissau", value: "GNB" },
	{ label: "Guyana", value: "GUY" },
	{ label: "Haiti", value: "HTI" },
	{ label: "Honduras", value: "HND" },
	{ label: "Hungary", value: "HUN" },
	{ label: "Iceland", value: "ISL" },
	{ label: "India", value: "IND" },
	{ label: "Indonesia", value: "IDN" },
	{ label: "Iran", value: "IRN" },
	{ label: "Iraq", value: "IRQ" },
	{ label: "Ireland", value: "IRL" },
	{ label: "Israel", value: "ISR" },
	{ label: "Italy", value: "ITA" },
	{ label: "Jamaica", value: "JAM" },
	{ label: "Japan", value: "JPN" },
	{ label: "Jordan", value: "JOR" },
	{ label: "Kazakhstan", value: "KAZ" },
	{ label: "Kenya", value: "KEN" },
	{ label: "Kiribati", value: "KIR" },
	{ label: "Kuwait", value: "KWT" },
	{ label: "Kyrgyzstan", value: "KGZ" },
	{ label: "Lao PDR", value: "LAO" },
	{ label: "Latvia", value: "LVA" },
	{ label: "Lebanon", value: "LBN" },
	{ label: "Lesotho", value: "LSO" },
	{ label: "Liberia", value: "LBR" },
	{ label: "Libya", value: "LBY" },
	{ label: "Liechtenstein", value: "LIE" },
	{ label: "Lithuania", value: "LTU" },
	{ label: "Luxembourg", value: "LUX" },
	{ label: "Madagascar", value: "MDG" },
	{ label: "Malawi", value: "MWI" },
	{ label: "Malaysia", value: "MYS" },
	{ label: "Maldives", value: "MDV" },
	{ label: "Mali", value: "MLI" },
	{ label: "Malta", value: "MLT" },
	{ label: "Marshall Islands", value: "MHL" },
	{ label: "Mauritania", value: "MRT" },
	{ label: "Mauritius", value: "MUS" },
	{ label: "Mexico", value: "MEX" },
	{ label: "Micronesia", value: "FSM" },
	{ label: "Moldova", value: "MDA" },
	{ label: "Monaco", value: "MCO" },
	{ label: "Mongolia", value: "MNG" },
	{ label: "Montenegro", value: "MNE" },
	{ label: "Morocco", value: "MAR" },
	{ label: "Mozambique", value: "MOZ" },
	{ label: "Myanmar", value: "MMR" },
	{ label: "Namibia", value: "NAM" },
	{ label: "Nauru", value: "NRU" },
	{ label: "Nepal", value: "NPL" },
	{ label: "Netherlands", value: "NLD" },
	{ label: "New Zealand", value: "NZL" },
	{ label: "Nicaragua", value: "NIC" },
	{ label: "Niger", value: "NER" },
	{ label: "Nigeria", value: "NGA" },
	{ label: "North Macedonia", value: "MKD" },
	{ label: "Norway", value: "NOR" },
	{ label: "Oman", value: "OMN" },
	{ label: "Pakistan", value: "PAK" },
	{ label: "Palau", value: "PLW" },
	{ label: "Panama", value: "PAN" },
	{ label: "Papua New Guinea", value: "PNG" },
	{ label: "Paraguay", value: "PRY" },
	{ label: "Peru", value: "PER" },
	{ label: "Philippines", value: "PHL" },
	{ label: "Poland", value: "POL" },
	{ label: "Portugal", value: "PRT" },
	{ label: "Qatar", value: "QAT" },
	{ label: "Romania", value: "ROU" },
	{ label: "Russia", value: "RUS" },
	{ label: "Rwanda", value: "RWA" },
	{ label: "Saint Kitts and Nevis", value: "KNA" },
	{ label: "Saint Lucia", value: "LCA" },
	{ label: "Saint Vincent and the Grenadines", value: "VCT" },
	{ label: "Samoa", value: "WSM" },
	{ label: "San Marino", value: "SMR" },
	{ label: "Sao Tome and Principe", value: "STP" },
	{ label: "Saudi Arabia", value: "SAU" },
	{ label: "Senegal", value: "SEN" },
	{ label: "Serbia", value: "SRB" },
	{ label: "Seychelles", value: "SYC" },
	{ label: "Sierra Leone", value: "SLE" },
	{ label: "Singapore", value: "SGP" }, // fixed from SGG
	{ label: "Slovakia", value: "SVK" },
	{ label: "Slovenia", value: "SVN" },
	{ label: "Solomon Islands", value: "SLB" },
	{ label: "Somalia", value: "SOM" },
	{ label: "South Africa", value: "ZAF" },
	{ label: "South Korea", value: "KOR" },
	{ label: "South Sudan", value: "SSD" },
	{ label: "Spain", value: "ESP" },
	{ label: "Sri Lanka", value: "LKA" },
	{ label: "Sudan", value: "SDN" },
	{ label: "Suriname", value: "SUR" },
	{ label: "Sweden", value: "SWE" },
	{ label: "Switzerland", value: "CHE" },
	{ label: "Syrian Arab Republic", value: "SYR" },
	{ label: "Tajikistan", value: "TJK" },
	{ label: "Tanzania", value: "TZA" },
	{ label: "Thailand", value: "THA" },
	{ label: "Timor-Leste", value: "TLS" },
	{ label: "Togo", value: "TGO" },
	{ label: "Tonga", value: "TON" },
	{ label: "Trinidad and Tobago", value: "TTO" },
	{ label: "Tunisia", value: "TUN" },
	{ label: "Turkey", value: "TUR" },
	{ label: "Turkmenistan", value: "TKM" },
	{ label: "Tuvalu", value: "TUV" },
	{ label: "Uganda", value: "UGA" },
	{ label: "Ukraine", value: "UKR" },
	{ label: "United Arab Emirates", value: "ARE" },
	{ label: "United Kingdom", value: "GBR" }, // corrected Great Britain → UK
	{ label: "United States of America", value: "USA" },
	{ label: "Uruguay", value: "URY" },
	{ label: "Uzbekistan", value: "UZB" },
	{ label: "Vanuatu", value: "VUT" },
	{ label: "Vatican City", value: "VAT" },
	{ label: "Venezuela", value: "VEN" },
	{ label: "Vietnam", value: "VNM" },
	{ label: "Yemen", value: "YEM" },
	{ label: "Zambia", value: "ZMB" },
	{ label: "Zimbabwe", value: "ZWE" },
];
export const CountryPhoneMask = {
	AFG: "+93 (##) ###-####", // Afghanistan
	ALB: "+355 (##) ###-####", // Albania
	DZA: "+213 (##) ###-####", // Algeria
	AND: "+376 ###-###", // Andorra
	AGO: "+244 (###) ###-###", // Angola
	ATG: "+1 (268) ###-####", // Antigua and Barbuda
	ARG: "+54 (###) ###-####", // Argentina
	ARM: "+374 ##-###-###", // Armenia
	AUS: "+61 (#) ####-####", // Australia
	AUT: "+43 (###) ###-####", // Austria
	AZE: "+994 (##) ###-##-##", // Azerbaijan
	BHS: "+1 (242) ###-####", // Bahamas
	BHR: "+973 ####-####", // Bahrain
	BGD: "+880 (##) ###-####", // Bangladesh
	BRB: "+1 (246) ###-####", // Barbados
	BLR: "+375 (##) ###-##-##", // Belarus
	BEL: "+32 (###) ###-###", // Belgium
	BLZ: "+501 ###-####", // Belize
	BEN: "+229 ##-##-####", // Benin
	BTN: "+975 ##-###-###", // Bhutan
	BOL: "+591 (##) ###-####", // Bolivia
	BIH: "+387 ##-###-###", // Bosnia and Herzegovina
	BWA: "+267 ##-###-###", // Botswana
	BRA: "+55 (##) #####-####", // Brazil
	BRN: "+673 ###-####", // Brunei Darussalam
	BGR: "+359 (##) ###-###", // Bulgaria
	BFA: "+226 ##-##-####", // Burkina Faso
	BDI: "+257 ##-##-####", // Burundi
	CPV: "+238 (###) ##-##", // Cabo Verde
	KHM: "+855 (##) ###-###", // Cambodia
	CMR: "+237 ####-####", // Cameroon
	CAN: "+1 (###) ###-####", // Canada
	CAF: "+236 ##-##-####", // Central African Republic
	TCD: "+235 ##-##-####", // Chad
	CHL: "+56 (#) ####-####", // Chile
	CHN: "+86 (##) ####-####", // China
	COL: "+57 (###) ###-####", // Colombia
	COM: "+269 ##-#####", // Comoros
	COG: "+242 ##-###-####", // Congo (Republic)
	COD: "+243 (###) ###-###", // Congo (DRC)
	CRI: "+506 ####-####", // Costa Rica
	HRV: "+385 (##) ###-###", // Croatia
	CUB: "+53 (#) ###-####", // Cuba
	CYP: "+357 ##-###-###", // Cyprus
	CZE: "+420 (###) ###-###", // Czechia
	DNK: "+45 ##-##-##-##", // Denmark
	DJI: "+253 ##-##-##-##", // Djibouti
	DMA: "+1 (767) ###-####", // Dominica
	DOM: "+1 (809) ###-####", // Dominican Republic (also 829/849)
	ECU: "+593 (#) ###-####", // Ecuador
	EGY: "+20 (##) ####-####", // Egypt
	SLV: "+503 ####-####", // El Salvador
	GNQ: "+240 ##-###-####", // Equatorial Guinea
	ERI: "+291 # ###-###", // Eritrea
	EST: "+372 ###-####", // Estonia
	SWZ: "+268 ##-##-####", // Eswatini
	ETH: "+251 (##) ###-####", // Ethiopia
	FJI: "+679 ##-#####", // Fiji
	FIN: "+358 (##) ###-####", // Finland
	FRA: "+33 (#) ##-##-##-##", // France
	GAB: "+241 #-##-##-##", // Gabon
	GMB: "+220 (###) ##-##", // Gambia
	GEO: "+995 (##) ###-###", // Georgia
	DEU: "+49 (####) ###-####", // Germany
	GHA: "+233 (##) ###-####", // Ghana
	GRC: "+30 (###) ###-####", // Greece
	GRD: "+1 (473) ###-####", // Grenada
	GTM: "+502 ####-####", // Guatemala
	GIN: "+224 ##-###-###", // Guinea
	GNB: "+245 ##-###-####", // Guinea-Bissau
	GUY: "+592 ###-####", // Guyana
	HTI: "+509 ##-##-####", // Haiti
	HND: "+504 ####-####", // Honduras
	HUN: "+36 (##) ###-###", // Hungary
	ISL: "+354 ###-####", // Iceland
	IND: "+91 (#####) #####", // India
	IDN: "+62 (##) ###-####", // Indonesia
	IRN: "+98 (###) ###-####", // Iran
	IRQ: "+964 (###) ###-####", // Iraq
	IRL: "+353 (##) ###-####", // Ireland
	ISR: "+972-#-###-####", // Israel
	ITA: "+39 (###) #######", // Italy
	JAM: "+1 (876) ###-####", // Jamaica
	JPN: "+81-##-####-####", // Japan
	JOR: "+962 #-####-####", // Jordan
	KAZ: "+7 (7##) ###-##-##", // Kazakhstan
	KEN: "+254 (###) ###-###", // Kenya
	KIR: "+686 ##-###", // Kiribati
	KWT: "+965 ####-####", // Kuwait
	KGZ: "+996 (###) ###-###", // Kyrgyzstan
	LAO: "+856 ##-###-###", // Laos
	LVA: "+371 ##-###-###", // Latvia
	LBN: "+961 ##-###-###", // Lebanon
	LSO: "+266 #-###-####", // Lesotho
	LBR: "+231 ##-###-###", // Liberia
	LBY: "+218 (##) ###-####", // Libya
	LIE: "+423 ###-####", // Liechtenstein
	LTU: "+370 (###) ##-###", // Lithuania
	LUX: "+352 ###-###-###", // Luxembourg
	MDG: "+261 ##-##-#####", // Madagascar
	MWI: "+265 #-###-####", // Malawi
	MYS: "+60-##-###-####", // Malaysia
	MDV: "+960 ###-####", // Maldives
	MLI: "+223 ##-##-####", // Mali
	MLT: "+356 ####-####", // Malta
	MHL: "+692 ###-####", // Marshall Islands
	MRT: "+222 ##-##-####", // Mauritania
	MUS: "+230 ###-####", // Mauritius
	MEX: "+52 (##) ####-####", // Mexico
	FSM: "+691 ###-####", // Micronesia
	MDA: "+373 (##) ###-###", // Moldova
	MCO: "+377 ##-###-###", // Monaco
	MNG: "+976 ##-##-####", // Mongolia
	MNE: "+382 ##-###-###", // Montenegro
	MAR: "+212 (##) ###-####", // Morocco
	MOZ: "+258 ##-###-###", // Mozambique
	MMR: "+95 ##-###-###", // Myanmar
	NAM: "+264 ##-###-####", // Namibia
	NRU: "+674 ###-####", // Nauru
	NPL: "+977-##-###-###", // Nepal
	NLD: "+31 ##-###-####", // Netherlands
	NZL: "+64 (#) ###-####", // New Zealand
	NIC: "+505 ####-####", // Nicaragua
	NER: "+227 ##-##-####", // Niger
	NGA: "+234 (###) ###-####", // Nigeria
	MKD: "+389 ##-###-###", // North Macedonia
	NOR: "+47 (###) ##-###", // Norway
	OMN: "+968 ####-####", // Oman
	PAK: "+92 (###) #######", // Pakistan
	PLW: "+680 ###-####", // Palau
	PAN: "+507 ###-####", // Panama
	PNG: "+675 ###-####", // Papua New Guinea
	PRY: "+595 (###) ###-###", // Paraguay
	PER: "+51 (###) ###-###", // Peru
	PHL: "+63 (###) ###-####", // Philippines
	POL: "+48 (###) ###-###", // Poland
	PRT: "+351 (##) ###-####", // Portugal
	QAT: "+974 ####-####", // Qatar
	ROU: "+40 (##) ###-####", // Romania
	RUS: "+7 (###) ###-##-##", // Russia
	RWA: "+250 (###) ###-###", // Rwanda
	KNA: "+1 (869) ###-####", // Saint Kitts and Nevis
	LCA: "+1 (758) ###-####", // Saint Lucia
	VCT: "+1 (784) ###-####", // Saint Vincent and the Grenadines
	WSM: "+685 ##-####", // Samoa
	SMR: "+378 ####-######", // San Marino
	STP: "+239 ##-#####", // Sao Tome and Principe
	SAU: "+966-#-###-####", // Saudi Arabia
	SEN: "+221 ##-###-####", // Senegal
	SRB: "+381 ##-###-###", // Serbia
	SYC: "+248 #-###-###", // Seychelles
	SLE: "+232 ##-######", // Sierra Leone
	SGP: "+65 ####-####", // Singapore
	SVK: "+421 (###) ###-###", // Slovakia
	SVN: "+386 (##) ###-###", // Slovenia
	SLB: "+677 ###-####", // Solomon Islands
	SOM: "+252 (##) ###-###", // Somalia
	ZAF: "+27 (##) ###-####", // South Africa
	KOR: "+82-##-###-####", // South Korea
	SSD: "+211 ##-###-####", // South Sudan
	ESP: "+34 (###) ###-###", // Spain
	LKA: "+94 ##-###-####", // Sri Lanka
	SDN: "+249 ##-###-####", // Sudan
	SUR: "+597 ###-####", // Suriname
	SWE: "+46 (##) ###-####", // Sweden
	CHE: "+41 ##-###-####", // Switzerland
	SYR: "+963 (##) ###-####", // Syria
	TWN: "+886 # ####-####", // Taiwan
	TJK: "+992 ##-###-####", // Tajikistan
	TZA: "+255 ##-###-####", // Tanzania
	THA: "+66-##-###-####", // Thailand
	TLS: "+670 ###-####", // Timor-Leste
	TGO: "+228 ##-###-###", // Togo
	TON: "+676 ###-####", // Tonga
	TTO: "+1 (868) ###-####", // Trinidad and Tobago
	TUN: "+216 ##-###-###", // Tunisia
	TUR: "+90 (###) ###-####", // Türkiye
	TKM: "+993 (##) ###-###", // Turkmenistan
	TUV: "+688 ##-####", // Tuvalu
	UGA: "+256 (###) ###-###", // Uganda
	UKR: "+380 (##) ###-##-##", // Ukraine
	ARE: "+971-#-###-####", // United Arab Emirates
	GBR: "+44 ####-###-###", // United Kingdom
	USA: "+1 (###) ###-####", // United States
	URY: "+598 #-###-##-##", // Uruguay
	UZB: "+998 ##-###-####", // Uzbekistan
	VUT: "+678 ##-#####", // Vanuatu
	VAT: "+379 ####-####", // Vatican City
	VEN: "+58 (###) ###-####", // Venezuela
	VNM: "+84 (##) ####-####", // Vietnam
	YEM: "+967-#-###-####", // Yemen
	ZMB: "+260 (##) ###-###", // Zambia
	ZWE: "+263 (##) ###-####", // Zimbabwe

	// --- Also include remaining UN members & observers not yet covered above ---
	ARE: "+971-#-###-####", // already included but kept for completeness
	BHS: "+1 (242) ###-####", // already included
	BGR: "+359 (##) ###-###", // already included
	BDI: "+257 ##-##-####", // already included
	BFA: "+226 ##-##-####", // already included
	BIH: "+387 ##-###-###", // already included
	KNA: "+1 (869) ###-####", // already included
	LCA: "+1 (758) ###-####", // already included
	VCT: "+1 (784) ###-####", // already included
	PSE: "+970 ##-###-####", // State of Palestine (observer state)
};

export const CurrencyCodes = [
	{ label: "Afghan Afghani", value: "AFN" },
	{ label: "Albanian Lek", value: "ALL" },
	{ label: "Algerian Dinar", value: "DZD" },
	{ label: "Euro", value: "EUR" }, // used by many EU countries
	{ label: "Angolan Kwanza", value: "AOA" },
	{ label: "East Caribbean Dollar", value: "XCD" }, // used by several Caribbean states
	{ label: "Argentine Peso", value: "ARS" },
	{ label: "Armenian Dram", value: "AMD" },
	{ label: "Aruban Florin", value: "AWG" },
	{ label: "Australian Dollar", value: "AUD" },
	{ label: "Azerbaijani Manat", value: "AZN" },
	{ label: "Bahamian Dollar", value: "BSD" },
	{ label: "Bahraini Dinar", value: "BHD" },
	{ label: "Bangladeshi Taka", value: "BDT" },
	{ label: "Barbados Dollar", value: "BBD" },
	{ label: "Belarusian Ruble", value: "BYN" },
	{ label: "Belize Dollar", value: "BZD" },
	{ label: "West African CFA Franc", value: "XOF" }, // used by WAEMU
	{ label: "Bermudian Dollar", value: "BMD" },
	{ label: "Bhutanese Ngultrum", value: "BTN" },
	{ label: "Indian Rupee", value: "INR" }, // also used in Bhutan
	{ label: "Bolivian Boliviano", value: "BOB" },
	{ label: "Bosnia and Herzegovina Convertible Mark", value: "BAM" },
	{ label: "Botswana Pula", value: "BWP" },
	{ label: "Brazilian Real", value: "BRL" },
	{ label: "Brunei Dollar", value: "BND" },
	{ label: "Bulgarian Lev", value: "BGN" },
	{ label: "Burundian Franc", value: "BIF" },
	{ label: "Cabo Verde Escudo", value: "CVE" },
	{ label: "Cambodian Riel", value: "KHR" },
	{ label: "Central African CFA Franc", value: "XAF" }, // used by CEMAC
	{ label: "Canadian Dollar", value: "CAD" },
	{ label: "Cayman Islands Dollar", value: "KYD" },
	{ label: "Chilean Peso", value: "CLP" },
	{ label: "Chinese Yuan Renminbi", value: "CNY" },
	{ label: "Colombian Peso", value: "COP" },
	{ label: "Comorian Franc", value: "KMF" },
	{ label: "Congolese Franc", value: "CDF" },
	{ label: "Costa Rican Colón", value: "CRC" },
	{ label: "Cuban Peso", value: "CUP" },
	{ label: "Czech Koruna", value: "CZK" },
	{ label: "Danish Krone", value: "DKK" },
	{ label: "Djiboutian Franc", value: "DJF" },
	{ label: "Dominican Peso", value: "DOP" },
	{ label: "Egyptian Pound", value: "EGP" },
	{ label: "Salvadoran Colón", value: "SVC" }, // now USD also used
	{ label: "Eritrean Nakfa", value: "ERN" },
	{ label: "Ethiopian Birr", value: "ETB" },
	{ label: "Falkland Islands Pound", value: "FKP" },
	{ label: "Fijian Dollar", value: "FJD" },
	{ label: "CFP Franc", value: "XPF" }, // used in French Pacific territories
	{ label: "Gambian Dalasi", value: "GMD" },
	{ label: "Georgian Lari", value: "GEL" },
	{ label: "Ghanaian Cedi", value: "GHS" },
	{ label: "Gibraltar Pound", value: "GIP" },
	{ label: "Guatemalan Quetzal", value: "GTQ" },
	{ label: "Guinean Franc", value: "GNF" },
	{ label: "Guyanese Dollar", value: "GYD" },
	{ label: "Haitian Gourde", value: "HTG" },
	{ label: "Honduran Lempira", value: "HNL" },
	{ label: "Hong Kong Dollar", value: "HKD" },
	{ label: "Hungarian Forint", value: "HUF" },
	{ label: "Icelandic Króna", value: "ISK" },
	{ label: "Indonesian Rupiah", value: "IDR" },
	{ label: "Iranian Rial", value: "IRR" },
	{ label: "Iraqi Dinar", value: "IQD" },
	{ label: "Israeli New Shekel", value: "ILS" },
	{ label: "Jamaican Dollar", value: "JMD" },
	{ label: "Japanese Yen", value: "JPY" },
	{ label: "Jordanian Dinar", value: "JOD" },
	{ label: "Kazakhstani Tenge", value: "KZT" },
	{ label: "Kenyan Shilling", value: "KES" },
	{ label: "North Korean Won", value: "KPW" },
	{ label: "South Korean Won", value: "KRW" },
	{ label: "Kuwaiti Dinar", value: "KWD" },
	{ label: "Kyrgyzstani Som", value: "KGS" },
	{ label: "Lao Kip", value: "LAK" },
	{ label: "Lebanese Pound", value: "LBP" },
	{ label: "Lesotho Loti", value: "LSL" },
	{ label: "South African Rand", value: "ZAR" }, // also used in Lesotho
	{ label: "Liberian Dollar", value: "LRD" },
	{ label: "Libyan Dinar", value: "LYD" },
	{ label: "Macanese Pataca", value: "MOP" },
	{ label: "Malagasy Ariary", value: "MGA" },
	{ label: "Malawian Kwacha", value: "MWK" },
	{ label: "Malaysian Ringgit", value: "MYR" },
	{ label: "Maldivian Rufiyaa", value: "MVR" },
	{ label: "Mauritanian Ouguiya", value: "MRU" },
	{ label: "Mauritian Rupee", value: "MUR" },
	{ label: "Mexican Peso", value: "MXN" },
	{ label: "Moldovan Leu", value: "MDL" },
	{ label: "Mongolian Tögrög", value: "MNT" },
	{ label: "Moroccan Dirham", value: "MAD" },
	{ label: "Mozambican Metical", value: "MZN" },
	{ label: "Myanmar Kyat", value: "MMK" },
	{ label: "Namibian Dollar", value: "NAD" },
	{ label: "Nepalese Rupee", value: "NPR" },
	{ label: "Netherlands Antillean Guilder", value: "ANG" },
	{ label: "New Zealand Dollar", value: "NZD" },
	{ label: "Nicaraguan Córdoba", value: "NIO" },
	{ label: "Nigerian Naira", value: "NGN" },
	{ label: "Norwegian Krone", value: "NOK" },
	{ label: "Omani Rial", value: "OMR" },
	{ label: "Pakistani Rupee", value: "PKR" },
	{ label: "Papua New Guinean Kina", value: "PGK" },
	{ label: "Paraguayan Guaraní", value: "PYG" },
	{ label: "Peruvian Sol", value: "PEN" },
	{ label: "Philippine Peso", value: "PHP" },
	{ label: "Polish Złoty", value: "PLN" },
	{ label: "Qatari Riyal", value: "QAR" },
	{ label: "Romanian Leu", value: "RON" },
	{ label: "Russian Ruble", value: "RUB" },
	{ label: "Rwandan Franc", value: "RWF" },
	{ label: "Saint Helena Pound", value: "SHP" },
	{ label: "Samoan Tala", value: "WST" },
	{ label: "São Tomé and Príncipe Dobra", value: "STN" },
	{ label: "Saudi Riyal", value: "SAR" },
	{ label: "Serbian Dinar", value: "RSD" },
	{ label: "Seychellois Rupee", value: "SCR" },
	{ label: "Sierra Leonean Leone", value: "SLE" },
	{ label: "Singapore Dollar", value: "SGD" },
	{ label: "Solomon Islands Dollar", value: "SBD" },
	{ label: "Somali Shilling", value: "SOS" },
	{ label: "South African Rand", value: "ZAR" },
	{ label: "South Sudanese Pound", value: "SSP" },
	{ label: "Sri Lankan Rupee", value: "LKR" },
	{ label: "Sudanese Pound", value: "SDG" },
	{ label: "Surinamese Dollar", value: "SRD" },
	{ label: "Swedish Krona", value: "SEK" },
	{ label: "Swiss Franc", value: "CHF" },
	{ label: "Syrian Pound", value: "SYP" },
	{ label: "New Taiwan Dollar", value: "TWD" },
	{ label: "Tajikistani Somoni", value: "TJS" },
	{ label: "Tanzanian Shilling", value: "TZS" },
	{ label: "Thai Baht", value: "THB" },
	{ label: "Tongan Paʻanga", value: "TOP" },
	{ label: "Trinidad and Tobago Dollar", value: "TTD" },
	{ label: "Tunisian Dinar", value: "TND" },
	{ label: "Turkish Lira", value: "TRY" },
	{ label: "Turkmenistan Manat", value: "TMT" },
	{ label: "Ugandan Shilling", value: "UGX" },
	{ label: "Ukrainian Hryvnia", value: "UAH" },
	{ label: "United Arab Emirates Dirham", value: "AED" },
	{ label: "Pound Sterling", value: "GBP" },
	{ label: "United States Dollar", value: "USD" },
	{ label: "Uruguayan Peso", value: "UYU" },
	{ label: "Uzbekistani Som", value: "UZS" },
	{ label: "Vanuatu Vatu", value: "VUV" },
	{ label: "Venezuelan Bolívar Soberano", value: "VES" },
	{ label: "Vietnamese Đồng", value: "VND" },
	{ label: "CFP Franc", value: "XPF" },
	{ label: "Yemeni Rial", value: "YER" },
	{ label: "Zambian Kwacha", value: "ZMW" },
	{ label: "Zimbabwean Dollar", value: "ZWL" },
];

export const AdSource = [
	{ label: "Credit Application", value: "credit application" },
	{ label: "Website", value: "website" },
	{ label: "Facebook", value: "facebook" },
	{ label: "Craigslist", value: "craigslist" },
	{ label: "Referral", value: "referral" },
];

export const militaryType = [
	{ label: "N/A", value: "n/a" },
	{ label: "Active Duty", value: "active duty" },
	{ label: "Reserve", value: "reserve" },
	{ label: "Veteran", value: "veteran" },
];

export const customerType = [
	{ label: "Personal", value: 0 },
	{ label: "Business", value: 1 },
	{ label: "WholeSale", value: 2 },
	{},
	{},
	{ label: "Purchase", value: 5 },
];

export const ownershipType = [
	{ label: "Own", value: "own" },
	{ label: "Rent", value: "rent" },
	{ label: "Other", value: "other" },
];

export const commissionType = [
	{ label: "Front", value: 0 },
	{ label: "Back", value: 1 },
	{ label: "Net Commissionable", value: 2 },
	{ label: "Net Profit", value: 3 },
];

export const fuelTypeList = [
	{ label: "Gasoline", value: "G" },
	{ label: "Diesel", value: "D" },
	{ label: "Diesel (B20 capable)", value: "B" },
	{ label: "Gas/Electric Hybrid", value: "Y" },
	{ label: "Diesel/Electric Hybrid", value: "DH" },
	{ label: "Plug-in Gas/Electric Hybrid", value: "PI" },
	{ label: "Electric with Gas Generator", value: "EG" },
	{ label: "Electric", value: "L" },
	{ label: "Hydrogen Fuel Cell", value: "H" },
	{ label: "Natural Gas", value: "N" },
	{ label: "Natural Gas/Propane", value: "NP" },
	{ label: "Propane", value: "P" },
	{ label: "Flex Fuel", value: "F" },
	{ label: "Gas/Oil Injected", value: "GI" },
	{ label: "Gas/Oil Premix", value: "GP" },
	{ label: "OTHER", value: "O" },
];

export const ATTACHMENT_CATEGORY = [
	{ label: "Credit Report", value: "Credit Report" },
	{ label: "ID Card", value: "ID Card" },
	{ label: "Income Documents", value: "Income Documents" },
	{ label: "Tax Documents", value: "Tax Documents" },
	{ label: "Utility Bill", value: "Utility Bill" },
	{ label: "Bank Statements", value: "Bank Statements" },
	{ label: "Title", value: "Title" },
	{ label: "Inspection/Appraisal", value: "Inspection/Appraisal" },
	{ label: "Insurance", value: "Insurance" },
	{ label: "Proof of Payment", value: "Payment" },
	{ label: "Other", value: "Other" },
];
export const OnlineLeadStatus = [
	{ label: "Active", value: 0 },
	{ label: "Sold", value: 1 },
	{ label: "Pending Sale", value: 2 },
	{ label: "Lost Lead", value: 3 },
	{ label: "Deleted/Trash", value: 4 },
	{ label: "Archive", value: 5 },
	{ label: "Appointment", value: 6 },
	{ label: "Seller", value: 7 },
	{ label: "Unknown", value: 8 },
	{ label: "Cold Lead", value: 9 },
];

export const OnlineCreditAppStatus = [
	{ label: "Active", value: 1 },
	{ label: "DeActive", value: 0 },
];

export const ActualMileageFlagOption = [
	{ label: "Actual", value: 0 },
	{ label: "Not Actual", value: 1 },
	{ label: "Exempt", value: 2 },
	{ label: "Excess", value: 3 },
	// { label: "Hours", value: 4 },
];
export const MessageZone = {
	DEAL: "Deal",
	ACCOUNT: "Account",
	CUSTOMER: "Customer",
	LEAD: "Lead",
	CREDITAPP: "CreditApp",
	LENDER: "Lender",
};
// this should contain Dealer specific variables
export const MESSAGE_Dealer_VARIABLES = {
	// Dealer stuff
	"<location_dealerNum>": "Dealer Number",
	"<location_fax>": "Dealer Fax",
	"<dealer_companyName>": "Dealer Name",
	"<location_address>": "Dealer Street",
	"<location_city>": "Dealer City",
	"<location_state>": "Dealer State",
	"<location_zipCode>": "Dealer Zip",
	"<location_phone>": "Dealer Phone",
	"<dealer_fullAddress>": "Full Address",
	"<todaysDate>": "Today's Date",
};

// this should contain dcTableCustomer specific variables
export const MESSAGE_CUSTOMER_VARIABLES = {
	// Buyer/DcTableCustomer stuff
	"<buyer_firstName>": "First Name",
	"<buyer_lastName>": "Last Name",
	"<buyer_middleName>": "Middle Name",
	"<buyer_creditScore>": "TU Score",
	"<buyer_creditScoreEfx>": "EFX Score",
	"<buyer_creditScoreXpn>": "XPN Score",
	...MESSAGE_Dealer_VARIABLES,
};

export const MESSAGE_COBUYER_VARIABLES = {
	// CoBuyer stuff
	"<coBuyer_firstName>": "Co First Name",
	"<coBuyer_lastName>": "Co Last Name",
};

// this should contain Vehicle specific variables
export const MESSAGE_Vehicle_VARIABLES = {
	// Vehicle stuff
	"<vehicle_year>": "Year",
	"<vehicle_make>": "Make",
	"<vehicle_model>": "Model",
	"<vehicle_stockNo>": "Stock Number",
	"<vehicle_vin>": "VIN",
};

// this should contain Lead specific variables
export const MESSAGE_LEAD_VARIABLES = {
	"<lead_firstName>": "First Name",
	"<lead_lastName>": "Last Name",
	"<lead_contactMname>": "Middle Name",
	// "<lead_businessName>": "Business Name",
	"<lead_year>": "Target Year",
	"<lead_make>": "Target Make",
	"<lead_model>": "Target Model",
	"<lead_color>": "Target Color",
	"<lead_stockNumber>": "Stock Number",
	...MESSAGE_Vehicle_VARIABLES,
	...MESSAGE_Dealer_VARIABLES,
};

// this should contain CreditApp specific variables
export const MESSAGE_CreditApp_VARIABLES = {
	"<creditApp_firstName>": "First Name",
	"<creditApp_lastName>": "Last Name",
	"<creditApp_middleName>": "Middle Name",
	"<creditApp_companyName>": "Business Name",
	"<creditApp_year>": "Target Year",
	"<creditApp_vehicleMake>": "Target Make",
	"<creditApp_vehicleModel>": "Target Model",
	"<creditApp_vehicleStockNum>": "Stock Number",
	"<creditApp_vin>": "vin",
	...MESSAGE_Vehicle_VARIABLES,
	...MESSAGE_Dealer_VARIABLES,
};
export const MESSAGE_Deal_VARIABLES = {
	// Deal Stuff
	"<deal_dealNumber>": "Deal Number",
	"<deal_loanDate>": "Deal Date",
	"<deal_price>": "Price",
	"<deal_amtFinanced>": "Amount Financed",
	"<deal_tax>": "Tax",
	"<deal_term>": "Term",
	"<deal_loanPeriod>": "Period",
	"<deal_apr>": "APR",
	"<deal_down>": "Down Payment",
	"<deal_totalNetTrade>": "Net Trade",
	"<deal_payment>": "Payment",

	"<deal_status>": "Deal Status",
	"<deal_type>": "Deal Type",
	"<deal_salesperson>": "Sales person",
	"<deal_RequestDocs>": "Request Docs",
};
export const MESSAGE_Insurance_VARIABLES = {
	"<insurance_insCompany>": "Insurance Company",
	"<insurance_policyNum>": "Policy Number",
	"<insurance_startDate>": "Start Date",
	"<insurance_endDate>": "End Date",
	"<insurance_agent>": "Agent",
	"<insurance_agentPhone>": "Agent Phone",
};
export const MESSAGE_ACCOUNT_VARIABLES = {
	"<account_accountNumber>": "accountNumber",
	"<account_subStatus>": "subStatus",
	"<account_regularPayment>": "payment",
	"<account_totalLateFees>": "totalLateFees",
	"<account_financeCompany>": "financeCompany",
	"<account_balance>": "balance",
	"<account_lastAmtPaid>": "lastAmtPaid",
	"<account_totalPaid>": "totalPaid",
	"<account_pastDueAmt>": "pastDueAmt",
	"<account_payoff>": "payoff",
	"<account_nextDueDate>": "nextDueDate",
	...MESSAGE_Insurance_VARIABLES,
	...MESSAGE_Dealer_VARIABLES,
	...MESSAGE_CUSTOMER_VARIABLES,
};

export const MESSAGE_Lender_VARIABLES = {
	"<lender_name>": "name",
	"<lender_contact1>": "contact1",
	"<lender_street>": "street",
	"<lender_city>": "city",
	"<lender_state>": "state",
	"<lender_zip>": "zip",
	"<lender_phone1>": "phone1",
	"<lender_phone2>": "phone2",
	"<lender_email>": "email",
	"<lender_website>": "website",
};

export const MESSAGE_TEMPLATE_VARIABLES = {
	...MESSAGE_CUSTOMER_VARIABLES,
	...MESSAGE_COBUYER_VARIABLES,
	...MESSAGE_Deal_VARIABLES,
	...MESSAGE_Vehicle_VARIABLES,
	...MESSAGE_Dealer_VARIABLES,
	...MESSAGE_Lender_VARIABLES,
	...MESSAGE_ACCOUNT_VARIABLES,
};

export const sellerFeeTypeList = [
	{ label: "Other", value: null },
	{ label: "Business Partner Automation (BPA)", value: "BPA" },
	{ label: "Electronic Registration Title (ERT)", value: "ERT" },
	{ label: "Electric Vehicle (EV)", value: "EV" },
	{ label: "Theft Deterrent", value: "theft" },
	{ label: "Surface Protection", value: "surface" },
	{ label: "Vehicle Single Insurance (VSI)", value: "VSI" },
];

export const driverLicenseOption = [
	{ label: "In-State Driver's License", value: "In-State Driver's License" },
	{
		label: "Out-of-State Driver's License",
		value: "Out-of-State Driver's License",
	},
	{
		label: "Consulate Issued ID / Matricula",
		value: "Consulate Issued ID / Matricula",
	},
	{ label: "ID Card", value: "ID Card" },
	{
		label: "Out-of-County / Int'l Driver's License",
		value: "Out-of-County / Int'l Driver's License",
	},
	{ label: "Passport", value: "Passport" },
	{
		label: "Restricted / Suspended Driver's License",
		value: "Restricted / Suspended Driver's License",
	},
];

export const canadaStateOption = [
	{ label: "Ontario", value: "ON" },
	{ label: "Quebec", value: "QC" },
	{ label: "Nova Scotia", value: "NS" },
	{ label: "New Brunswick", value: "NB" },
	{ label: "Manitoba", value: "MB" },
	{ label: "British Columbia", value: "BC" },
	{ label: "Prince Edward Island", value: "PE" },
	{ label: "Saskatchewan", value: "SK" },
	{ label: "Alberta", value: "AB" },
	{ label: "Newfoundland and Labrador", value: "NL" },
];

export const isTaxableOption = [
	{ value: "true", label: "Yes" },
	{ value: "false", label: "No" },
];

export const rollOptions = [
	// here for informative reasons
	// {label: "No Roll", value: 0},
	{ label: "Price", value: 10 },
	{ label: "Down", value: 20 },
	{ label: "Interest (APR)", value: 40 },
	{ label: "Term", value: 90 },
];

export const leaseRollOptions = [
	{ label: "Price", value: 10 },
	{ label: "Down/Reduction", value: 20 },
	{ label: "Interest (APR)", value: 30 },
	{ label: "Term", value: 40 },
	{ label: "Residual", value: 60 },
];
export const rtoRollOptions = [
	{ label: "Price", value: 10 },
	{ label: "Down/Reduction", value: 20 },
	{ label: "Markup", value: 35 },
	{ label: "Term", value: 40 },
	{ label: "Residual", value: 60 },
];
export const companyFeaturesList = [
	{ value: "isWordpressActive", label: "Wordpress" },
	{ value: "useKall8", label: "Kall8" },
	{ value: "sendXMRadio", label: "SiriusXM" },
	{ value: "useTrueValue", label: "TrueValue" },
	{ value: "sendCarfax", label: "Carfax" },
	{ value: "sendAutoCheck", label: "Autocheck" },
	{ value: "useLenderArea", label: "Lender Area" },
	{ value: "useCRM", label: "CRM Area" },
	{ value: "sendWebsite", label: "Hosting" },
	{ value: "sendExternalWebsite", label: "External Inventory" },
	{ value: "sendXML", label: "XML Inventory" },
	{ value: "usedCreditAppArea", label: "Credit App Area" },
	{ value: "sendCBC", label: "CBC" },
	{ value: "useAndroid", label: "Android" },
	{ value: "usePop3", label: "Pop3" },
	{ value: "usePreviousOwner", label: "Previous Owner" },
	{ value: "kbbidws", label: "KBB IDWS" },
	{ value: "sendFacebook", label: "Facebook.com" },
	{ value: "useIphone", label: "iPhone" },
	{ value: "sendTitleTec", label: "TitleTec" },
	{ value: "sendBlockchain", label: "Blockchain" },
	{ value: "useUACC", label: "UACC" },
	{ value: "useManheim", label: "Manheim" },
];

export const locationFeatureList = [
	{ value: "keyless", label: "Keyless" },
	{ value: "dc", label: "DMS" },
	{ value: "cr", label: "Credit Reports" },
	{ value: "qb", label: "QuickBook" },
	{ value: "ls", label: "Leasing" },
	{ value: "nls", label: "RTO" },
	{ value: "fn", label: "BHPH" },
	{ value: "ps", label: "Part & Service" },
	{ value: "psTimeClock", label: "Time Clock" },
	{ value: "psBarCode", label: "BarCode" },
];

export const paymentMethod = [
	// 🔹 Most Common at Dealerships
	{ value: "Cash", label: "Cash" },
	{ value: "Credit Card", label: "Credit Card" },
	{ value: "Debit Card", label: "Debit Card" },
	{ value: "Check", label: "Check" },
	{ value: "ACH", label: "ACH" },

	// 🔹 Popular Digital & Wallet Options
	{ value: "Zelle", label: "Zelle" },
	{ value: "Venmo", label: "Venmo" },
	{ value: "PayPal", label: "PayPal" },
	{ value: "Cash App", label: "Cash App" },

	// 🔹 Bank-Based / Formal Payments
	{ value: "Cashiers Check", label: "Cashiers Check" },
	{ value: "Money Order", label: "Money Order" },
	{ value: "E-Check", label: "E-Check" },
	{ value: "MoneyGram", label: "MoneyGram" },

	// 🔹 Less Common or Internal Use
	{ value: "DriveOff", label: "DriveOff" },
	{ value: "Credit Issued", label: "Credit Issued" },
	{ value: "Rebate", label: "Rebate" },

	// 🔹 Emerging / Rare
	{ value: "Crypto", label: "Crypto" },

	// 🔹 Fallback Option
	{ value: "Other", label: "Other" },
];
export const purchaseType = [
	...paymentMethod,
	{ value: "flooring", label: "Flooring" },
	{ value: "draft", label: "Draft" },
	{ value: "consignment", label: "Consignment" },
	{ value: "certified Check", label: "Certified Check" },
];

export const driveType = [
	{ label: "Front-wheel drive (FWD)", value: "FWD" },
	{ label: "Rear-wheel drive (RWD)", value: "RWD" },
	{ label: "All-wheel drive (AWD)", value: "AWD" },
	{ label: "Four-wheel drive (4WD)", value: "4WD" },
];

export const smogCheck = [
	{ label: "Not Checked", value: 0 },
	{ label: "Passed", value: 1 },
	{ label: "Failed", value: 2 },
];

export const credit700Products = {
	saveOnly: "SAVEONLY",
	credit: "CREDIT",
	prescreen: "PRESCREEN",
};

export const credit700Lenders = {
	routeOne: "R1",
	dealerTrack: "DT",
	cudl: "CUDL",
	appOne: "APPONE",
};

export const credit700Bureaus = {
	experian: "XPN",
	transUnion: "TU",
	equifax: "EFX",
};
export const titleBrands = [
	{ value: "Clean", label: "Clean" },
	{ value: "Collision", label: "Collision" },
	{ value: "Damaged", label: "Damaged" },
	{ value: "Water-Damage", label: "Water Damage" },
	{ value: "Storm-Damage", label: "Storm Damage" },
	{ value: "Dismantled", label: "Dismantled" },
	{ value: "Grey-Market", label: "Grey Market" }, //(Non-USA)
	{ value: "Junk", label: "Junk" },
	{ value: "Lemon", label: "Lemon law buyback" }, //(Warranty Return)
	{ value: "Police", label: "Original police" },
	{ value: "Taxi", label: "Original Taxi" },
	{ value: "Park Trailer", label: "Park Trailer" },
	{ value: "Rebuilt", label: "Rebuilt" },
	{ value: "Reconditioned", label: "Reconditioned" },
	{ value: "Remanufactured", label: "Remanufactured" },
	{ value: "Replica", label: "Replica" },
	{ value: "Revived Junk", label: "Revived Junk" },
	{ value: "Revived Salvage", label: "Revived Salvage" },
	{ value: "Recycled", label: "Recycled" },
	{ value: "Salvage", label: "Salvage" },
	{ value: "Scrap Vehicle", label: "Scrap Vehicle" },
	{ value: "Totaled", label: "Totaled" },
	{ value: "Warranty Returned", label: "Warranty Returned" },
	{ value: "Vandalism", label: "Vandalism" },
	{ value: "TMU", label: "TMU" }, //True Mileage Unknown
	{ value: "Municipal", label: "Municipal Vehicle" },
	{ value: "Tripped", label: "Tripped" },
	{ value: "Flood", label: "Flood" },
];

/**
 * PepperPay option lists
 */
export const MailingType = [
	{ value: "DBA Address", label: "DBA Address" },
	{ value: "Legal Address", label: "Legal Address" },
];
export const jobTitles = [
	{ value: "CEO", label: "CEO" },
	{ value: "CFO", label: "CFO" },
	{ value: "Chairman", label: "Chairman" },
	{ value: "Co-owner", label: "Co-owner" },
	{ value: "Comptroller", label: "Comptroller" },
	{ value: "Controller", label: "Controller" },
	{ value: "Director", label: "Director" },
	{ value: "General Manager", label: "General Manager" },
	{ value: "Office Manager", label: "Office Manager" },
	{ value: "Owner", label: "Owner" },
	{ value: "Partner", label: "Partner" },
	{ value: "President", label: "President" },
	{ value: "Treasurer", label: "Treasurer" },
	{ value: "Vice President", label: "Vice President" },
];
export const OwnershipTypePeperpay = [
	{ value: "Individual/Sole Proprietor", label: "Individual/Sole Proprietor" },
	{ value: "Partnership", label: "Partnership" },
	{ value: "LLC", label: "LLC" },
	{ value: "Association/Estate/Trust", label: "Association/Estate/Trust" },
	{
		value: "Government(Federal, State, Local)",
		label: "Government(Federal, State, Local)",
	},
	{ value: "Corporation - Chapter S, C", label: "Corporation - Chapter S, C" },
	{ value: "Tax Exempt Organization", label: "Tax Exempt Organization" },
	{
		value: "Medical or Legal Corporation",
		label: "Medical or Legal Corporation",
	},
	{ value: "International Organization", label: "International Organization" },
];
export const AccountOwnership = [
	{ value: "business", label: "business" },
	{ value: "personal", label: "personal" },
];
export const BankruptcyFiled = [
	{ value: "never filed", label: "never filed" },
	{ value: "business bankruptcy", label: "business bankruptcy" },
	{ value: "personal bankruptcy", label: "personal bankruptcy" },
];
export const BankAccountType = [
	{ value: "Checking", label: "Checking" },
	{ value: "Savings", label: "Savings" },
];
export const typeOfGoodsServices = [
	{ value: "Retail", label: "Retail" },
	{ value: "Retail W Tip", label: "Retail W Tip" },
	{ value: "Mail Phone", label: "Mail Phone" },
	{ value: "Internet", label: "Internet" },
	{ value: "Restaurant", label: "Restaurant" },
	{ value: "Fast Food", label: "Fast Food" },
	{ value: "Lodging", label: "Lodging" },
	{ value: "QRS", label: "QRS" },
	{ value: "Convenience", label: "Convenience" },
	{ value: "Public Sector", label: "Public Sector" },
	{ value: "Petroleum", label: "Petroleum" },
	{ value: "Utility", label: "Utility" },
	{ value: "Health Care", label: "Health Care" },
	{ value: "Other", label: "Other" },
];
export const LocationAreaZoned = [
	{ value: "Commercial", label: "Commercial" },
	{ value: "Industrial", label: "Industrial" },
	{ value: "Residential", label: "Residential" },
];
export const locationBuildingType = [
	{ value: "Shopping center", label: "Shopping center" },
	{ value: "Office Building", label: "Office Building" },
	{ value: "Industrial Building", label: "Industrial Building" },
	{ value: "Residence", label: "Residence" },
	{ value: "Other", label: "Other" },
];
export const LocationMerchant = [
	{ value: "Rents", label: "Rents" },
	{ value: "Owns", label: "Owns" },
];
export const LocationSquareFootage = [
	{ value: "0-500", label: "0-500" },
	{ value: "501-2500", label: "501-2500" },
	{ value: "2501-5000", label: "2501-5000" },
	{ value: "5001-10000", label: "5001-10000" },
	{ value: "10000+", label: "10000+" },
];
export const BillingFrequency = [
	{ label: "Daily", value: "Daily" },
	{ label: "Weekly", value: "Weekly" },
	// { label: "Bi-Weekly", value: "Bi-Weekly" },
	{ label: "Monthly", value: "Monthly" },
	// { label: "Quarterly", value: "Quarterly" },
	// { label: "Annual", value: "Annual" },
	// { label: "Hourly", value: "Hourly" },
	// { label: "Custom", value: "Custom" },
];
export const PmtType = {
	INVOICE: "Invoice",
	LOAN: "Loan",
	LEASE: "Lease",
	RENT: "Rent",
	DOWN: "Down",
	PICKUP: "Pickup",
	DEFERRED: "Deferred",
	DEPOSIT: "Deposit",
	PAYOFF: "PayOff",
};
export const PmtMode = {
	REGULAR: 0,
	PRINCIPAL_ONLY: 1,
	INTEREST_ONLY: 2,
	ESCROW: 3,
	LEASE_RENT: 4,
	ADJUSTMENT: 5,
	LATE_FEE: 6,
	DEPOSIT: 7,
	PICKUP: 8,
	DOWN: 9,
	DEFERRED: 10,
	MILEAGE: 11,
	INSURANCE: 12,
	CUSTOM: 99,
	PAYOFF: 100,
};
export const PaymentType = [
	{ label: "Invoice", value: "Invoice" },
	{ label: "Loan", value: "Loan" },
	{ label: "Lease", value: "Lease" },
	{ label: "Rent", value: "Rent" },
	{ label: "Down", value: "Down" },
	{ label: "Pickup", value: "Pickup" },
	{ label: "Deposit", value: "Deposit" },
];
export const downPaymentType = [
	{ label: "Down", value: "Down" },
	{ label: "Deposit", value: "Deposit" },
	{ label: "Rebate", value: "Rebate" },
];
export const PaymentMode = [
	{ value: 0, label: "Regular" },
	{ value: 1, label: "Principal Only" },
	{ value: 2, label: "Interest Only" },
	// { value: 3, label: "Escrow" },
	//{ value: 4, label: "Lease / Rent" },
	{ value: 5, label: "Adjustment" },
	{ value: 6, label: "Late Fee" },
	{ value: 7, label: "Deposit" },
	{ value: 8, label: "PickUp" },
	{ value: 9, label: "Down" },
	// { value: 10, label: "Deferred" },
	{ value: 11, label: "Mileage" },
	{ value: 12, label: "Insurance" },
	{ value: 99, label: "Custom" },
	{ value: 100, label: "PayOff" },
];
export const PaymentTypeToModeMapping = {
	Invoice: [0], // Regular
	Loan: [0, 1, 2, 5, 6, 99, 100], //Regular, Principal Only, Interest Only, Adjustment, LATE FEE, Mileage, Insurance, Custom
	Lease: [0, 5, 6, 11, 12, 99, 100], // Lease / Rent, Adjustment, LATE FEE, Mileage, Insurance
	Rent: [0, 5, 6, 11, 12, 99, 100], // Lease / Rent, Adjustment, LATE FEE, Mileage, Insurance
	Down: [9], // Down
	Pickup: [8], // PickUp
	// Deferred: [10], // Deferred
	Deposit: [7], // Deposit
};
export const PaymentStatus = [
	{ value: "completed", label: "Completed" },
	{ value: "pending", label: "Pending" },
	{ value: "failed", label: "Failed" },
	{ value: "inProgress", label: "In Progress" },
	{ value: "canceled", label: "Canceled" },
	{ value: "refundInitiated", label: "Refund Initiated" },
	{ value: "refunded", label: "Refunded" },
	{ value: "partiallyPaid", label: "Partially Paid" },
	{ value: "overPaid", label: "Overpaid" },
	{ value: "void", label: "Void" },
	{ value: "authorized", label: "Authorized" },
	{ value: "chargeback", label: "Chargeback" },
	{ value: "dispute", label: "Dispute" },
	{ value: "settled", label: "Settled" },
];

// Account status  Lable
//* this list shoud be exact as table records
export const AccountStatus = [
	{ value: 5, main: 1, label: "TRANSFERRED" }, // Account transferred to another office
	{ value: 10, main: 1, label: "Renewed" }, // RENEWED from CloseSubStatus
	{ value: 11, main: 0, label: "Current" }, // CURRENT from OpenSubStatus
	{ value: 13, main: 1, label: "Paid Off" }, // PAID_OFF from CloseSubStatus
	{ value: 20, main: 1, label: "Void" }, // VOID from CloseSubStatus
	{ value: 61, main: 1, label: "Paid Surrender" }, // PAID_SURRENDER from CloseSubStatus
	{ value: 62, main: 1, label: "Paid Collection" }, // PAID_COLLECTION from CloseSubStatus
	{ value: 63, main: 1, label: "Paid Repossession" }, // PAID_REPOSSESSION from CloseSubStatus
	{ value: 64, main: 1, label: "Paid Chargeoff" }, // PAID_CHARGEOFF from CloseSubStatus
	{ value: 65, main: 1, label: "Paid Foreclosure" }, // Paid Foreclosure (same as original)
	{ value: 67, main: 1, label: "Bankruptcy" }, // BANKRUPTCY from CloseSubStatus
	{ value: 68, main: 1, label: "Paid For Less" }, // PAID_FOR_LESS from CloseSubStatus
	{ value: 69, main: 1, label: "Bankruptcy13" }, // BANKRUPTCY13 from CloseSubStatus
	{ value: 71, main: 0, label: "Late 30" }, // LATE_30 from OpenSubStatus
	{ value: 78, main: 0, label: "Late 60" }, // LATE_60 from OpenSubStatus
	{ value: 80, main: 0, label: "Late 90" }, // LATE_90 from OpenSubStatus
	{ value: 82, main: 0, label: "Late 120" }, // LATE_120 from OpenSubStatus
	{ value: 83, main: 0, label: "Late 150" }, // LATE_150 from OpenSubStatus
	{ value: 84, main: 0, label: "Late 180" }, // LATE_180 from OpenSubStatus
	{ value: 85, main: 0, label: "Consumer Lost Now Found" }, // CONSUMER_LOST_NOW_FOUND from CloseSubStatus
	{ value: 88, main: 1, label: "Insurance Claim" }, // INSURANCE_CLAIM from CloseSubStatus
	{ value: 89, main: 1, label: "Deed Received" }, // DEED_RECEIVED (same as original)
	{ value: 91, main: 1, label: "Early Default" }, // EARLY_DEFAULT from CloseSubStatus
	{ value: 92, main: 1, label: "Insurance Claim" }, // INSURANCE_CLAIM from CloseSubStatus (duplicate entry)
	{ value: 93, main: 1, label: "Collections" }, // COLLECTIONS from CloseSubStatus
	{ value: 94, main: 1, label: "Foreclosure" }, // FORECLOSURE (same as original)
	{ value: 95, main: 1, label: "Surrender" }, // SURRENDER from CloseSubStatus
	{ value: 96, main: 1, label: "Repossession" }, // REPOSSESSION from CloseSubStatus
	{ value: 97, main: 1, label: "Unpaid Loss" }, // UNPAID_LOSS from CloseSubStatus
	{ value: 98, main: 1, label: "Consumer Lost" }, // CONSUMER_LOST from CloseSubStatus
	{ value: 99, main: 1, label: "Deleted" }, // DELETED (same as original)
];
export const DateRange = [
	{ value: "Today", label: "Today" },
	{ value: "This Week", label: "This Week" },
	{ value: "This Month", label: "This Month" },
	{ value: "This Year", label: "This Year" },
	{ value: "Last 180 Days", label: "Last 180 Days" },
	{ value: "Last Week", label: "Last Week" },
	{ value: "Last Month", label: "Last Month" },
	{ value: "Last Year", label: "Last Year" },
	{ value: "Last Two Years", label: "Last Two Years" },
	{ value: "Last Four Years", label: "Last Four Years" },
	{ value: "All", label: "All" },
];
export const employmentStatus = [
	{ label: "Employed", value: "Employed" },
	{ label: "Unemployed", value: "Unemployed" },
	{ label: "Self-Employed", value: "Self-Employed" },
	{ label: "Student", value: "Student" },
	{ label: "Retired", value: "Retired" },
	{ label: "Active Military", value: "Active Military" },
	{ label: "Retired Military", value: "Retired Military" },
	{ label: "Other", value: "Other" },
];
export const dateRange = [
	{ label: "Today", value: "Today" },
	{ label: "This Week", value: "This Week" },
	{ label: "This Month", value: "This Month" },
	{ label: "This Year", value: "This Year" },
	{ label: "Last 180 Days", value: "Last 180 Days" },
	{ label: "Last Week", value: "Last Week" },
	{ label: "Last Month", value: "Last Month" },
	{ label: "Last Year", value: "Last Year" },
	{ label: "Last Two Years", value: "Last Two Years" },
	{ label: "Last 4 Years", value: "Last 4 Years" },
];
export const tireTypes = [
	{ label: "ALL_SEASON", value: "All Season" },
	{ label: "SUMMER", value: "Summer" },
	{ label: "WINTER", value: "Winter" },
	{ label: "ALL_TERRAIN", value: "All Terrain" },
	{ label: "MUD", value: "Mud" },
	{ label: "PERFORMANCE", value: "Performance" },
	{ label: "TOURING", value: "Touring" },
	{ label: "TRACK_COMPETITION", value: "Track and Competition" },
	{ label: "RUN_FLAT", value: "Run Flat" },
	{ label: "ECO", value: "Eco" },
	{ label: "TRUCK", value: "Truck" },
	{ label: "RECAP", value: "Recap" },
];
export const vehicleTypes = [
	"RV",
	"TRUCK",
	"MARINE",
	"MPV",
	"SEMI-TRAILER TRUCK",
	"SEMI-TRUCKS",
	"OTHER",
	"BOAT",
];
export const acctStatusOptions = [
	{ value: 0, label: "Unpaid" },
	{ value: 1, label: "Paid" },
	{ value: 2, label: "Declined" },
	{ value: 3, label: "Canceled" },
];

// Used for the privileges selector
export const privilegeSelectorOptions = [
	{ label: "Unwind Deal", value: "unwindDeal", checked: false },
	{ label: "Delete Deal", value: "deleteDeal", checked: false },
	{ label: "Save Deal", value: "saveDeal", checked: false },
	{ label: "Deal Financing Tab", value: "dealFinancingTab", checked: false },
	{ label: "Deal Forms Tab", value: "dealFormsTab", checked: false },
	{
		label: "Deal Commissions Tab",
		value: "dealCommissionsTab",
		checked: false,
	},
	{ label: "Create New Deal", value: "dealNew", checked: false },
	{ label: "Recap", value: "recap", checked: false },
	{ label: "Transfer Deal To Sold", value: "transferToSold", checked: false },
	{ label: "Pull Customer Credit", value: "pullCredit", checked: false },
	{ label: "Add New Customer", value: "customerNew", checked: false },
	{ label: "Save Customer", value: "customerSave", checked: false },
	{ label: "Add New Inventory", value: "inventoryNew", checked: false },
	{ label: "Save Inventory", value: "inventorySave", checked: false },
	{
		label: "Inventory Costs Tab",
		value: "inventoryCostsTab",
		checked: false,
	},
	{
		label: "Inventory Advertising",
		value: "inventoryAdvertising",
		checked: false,
	},
];

export const bhphPrivilegeSelectorOptions = [
	{ label: "Delete Account", value: "deleteAccount", checked: false },
	{ label: "Edit Payment", value: "editPayment", checked: false },
	{ label: "Create New Account", value: "createNewAccount", checked: false },
	{ label: "Access to BHPH", value: "accessBhph", checked: false },
	{ label: "Setup Autopay", value: "setupAutopay", checked: false },
	{ label: "Edit BHPH Setting", value: "editSetting", checked: false },
	{
		label: "Access General Reports",
		value: "accessGeneralReports",
		checked: false,
	},
	{
		label: "Access Account Report",
		value: "accessAccountReport",
		checked: false,
	},
	{ label: "Edit Account", value: "editAccount", checked: false },
	{ label: "Loan Modification", value: "loanModification", checked: false },
	{ label: "Postpone Payment", value: "postponePayment", checked: false },
	{ label: "Access Lates", value: "accessLates", checked: false },
	{ label: "Access Adjustments", value: "accessAdjustments", checked: false },
	{ label: "Update Insurance", value: "updateInsurance", checked: false },
];

// Used for saving a privilege object
export const privileges = {
	unwindDeal: false,
	deleteDeal: false,
	saveDeal: false,
	recap: false,
	transferToSold: false,
	dealFinancingTab: false,
	dealFormsTab: false,
	dealCommissionsTab: false,
	dealNew: false,
	pullCredit: false,
	customerNew: false,
	customerSave: false,
	inventoryNew: false,
	inventorySave: false,
	inventoryCostsTab: false,
	inventoryAdvertising: false,
};

// sets default bhph privileges
export const bhphPrivileges = {
	deleteAccount: false, //
	editPayment: false, //
	createNewAccount: false, //
	accessBhph: false, //
	setupAutopay: false, //
	editSetting: false, //
	accessGeneralReports: false, //
	accessAccountReport: false, //
	editAccount: false, //
	loanModification: false, //
	postponePayment: false, //
	accessLates: false, //
	accessAdjustments: false, //
	updateInsurance: false, //
};

export const digitzsCardTypes = [
	{ label: "Select card type", value: "" },
	{ label: "American Express", value: "americanExpress" },
	{ label: "Discover", value: "discover" },
	{ label: "Master Card", value: "masterCard" },
	{ label: "VISA", value: "visa" },
];
